module.exports = __webpack_public_path__ + "img/ch14_10_兔摊摸兔.b26c4685.jpg";